import React from "react";

import { Grid } from "@mui/material";
import { Skeleton } from "@mui/material";

const InviteSupplierModalSkeleton = () => {
  const heightInput = 60;

  return (
    <Grid container direction="row" justifyContent="flex-start" spacing={2}>
      <Grid item xs={12}>
        <Skeleton variant="text" width="100%" height={heightInput} />
      </Grid>
      <Grid item xs={12}>
        <Skeleton variant="text" width="100%" height={heightInput} />
      </Grid>
    </Grid>
  );
};

export default InviteSupplierModalSkeleton;
